import axios from 'axios';

export function paymentPlanCreate(
	participant: string,
	legalEntity: string,
	recipient: string,
	invoices: string[],
	creditNotes: string[],
	debitNotes: string[],
	payments: string[],
	interest: string,
	interestApplied: boolean,
	indemnification: string,
	indemnificationApplied: Boolean,
	indemnificationMin: string,
	indemnificationMax: string,
	installmentFrequency: string,
	maxInstallments: number | null,
	maxInstallmentAmount: { amount: { value: number; currency: string }; frequency: string } | null,
	dateFirstInstallment: Date
) {
	const constraints: {
		max_installments?: number;
		max_installment_amount?: { amount: { value: string; currency: string }; frequency: string };
	} = {};
	if (maxInstallmentAmount !== null && maxInstallmentAmount.amount.value > 0) {
		constraints.max_installment_amount = {
			amount: {
				value: parseFloat(String(maxInstallmentAmount.amount.value)).toFixed(2),
				currency: maxInstallmentAmount.amount.currency
			},
			frequency: maxInstallmentAmount.frequency
		};
	} else if (maxInstallments !== null) {
		constraints.max_installments = maxInstallments;
	}

	const payload = {
		participant: participant,
		legal_entity: legalEntity,
		recipient: recipient,
		invoices: invoices,
		credit_notes: creditNotes,
		debit_notes: debitNotes,
		payments: payments,
		conditions: {
			installment_frequency: installmentFrequency,
			interest: parseFloat(interest).toFixed(2),
			interest_applied: interestApplied,
			indemnification: parseFloat(indemnification).toFixed(2),
			indemnification_applied: indemnificationApplied,
			indemnification_min: parseFloat(indemnificationMin).toFixed(2),
			indemnification_max: parseFloat(indemnificationMax).toFixed(2)
		},
		constraints,
		due_date: `${dateFirstInstallment.getFullYear()}-${String(dateFirstInstallment.getMonth() + 1).padStart(2, '0')}-${String(dateFirstInstallment.getDate()).padStart(2, '0')}`
	};

	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/payment-plan/v1/create-payment-plan`, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}

export function paymentPlanCancel(
	participant: string,
	legalEntity: string,
	recipient: string,
	paymentPlan: string
) {
	const payload = {
		participant: participant,
		legal_entity: legalEntity,
		recipient: recipient,
		payment_plan: paymentPlan
	};

	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/payment-plan/v1/cancel-payment-plan`, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}
